import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-164" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-slate-200 bg-white p-4 pr-10 text-slate-900 shadow-lg" aria-live="polite" data-id="element-165" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded-md p-1 text-slate-400 transition-colors duration-150 ease-out hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500" aria-label="Dismiss notice" data-id="element-166" data-mp="1sg5ydrzt3n61">
            <XIcon className="h-4 w-4" data-id="element-167" data-mp="1ngtcb9grek4i" />
          </button>
          <div className="flex gap-3" data-id="element-168" data-mp="1nf8fteavwr40">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-700" aria-hidden="true" data-id="element-169" data-mp="19peu34uoemyi" />
            <div data-id="element-170" data-mp="1eg4xwdngehr3">
              <p className="text-xs font-semibold text-teal-700" data-id="element-171" data-mp="1egn4o47qsed9">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-slate-600" data-id="element-172" data-mp="zriikbxttpzv">
                Once your purchase is complete you receive the
                <br data-id="element-173" data-mp="14rd748u4q3hr" />
                <span className="font-semibold text-slate-900" data-id="element-174" data-mp="14qldv4o08hun">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-slate-500" data-id="element-175" data-mp="qrc70vlov03c">Instant digital access by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}